<template>
	<Modal title="Error">
		<p class="text-center"><strong>An error occurred, please reload the page!</strong></p>
		<p
			class="text-center"
			v-if="error"
		>{{ error }}</p>
		<template v-slot:footer>
			<button
				class="btn btn-light"
				@click="reload"
			>Reload page</button>
		</template>
	</Modal>
</template>

<script>
export default {
	props: ["error"],
	methods: {
		reload() {
			window.location.reload();
		}
	}
};
</script>